import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultApi, Pages } from "@vviinn/user-managment-client-ts";
import { FetchableState } from "..";
import { serializeModel } from "../../../api";

type PagesState = FetchableState & {
  pages: Pages["value"];
  errorMessage?: string;
};

const initialState: PagesState = {
  pages: [],
  loading: false,
  error: false,
  status: "idle",
};
const pagesSlice = createSlice({
  name: "pages",
  initialState,
  reducers: {
    resetPages: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPages.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.status = "loading";
      state.errorMessage = undefined;
      state.pages = initialState.pages;
    });
    builder.addCase(fetchPages.fulfilled, (state, { payload }) => {
      state.pages = payload;
      state.error = false;
      state.loading = false;
      state.status = "fulfilled";
      state.errorMessage = undefined;
    });
    builder.addCase(fetchPages.rejected, (state, { error }) => {
      state.loading = false;
      state.error = true;
      state.status = "error";
      state.pages = initialState.pages;
      state.errorMessage = error.message;
    });
  },
});

export default pagesSlice.reducer;

export const { resetPages } = pagesSlice.actions;

export const fetchPages = createAsyncThunk(
  "pages/fetch",
  async (api: DefaultApi) => {
    const response = await api.getPages();
    return response.value.map(serializeModel);
  },
);
